
import { useContext } from 'react';

import { Island } from '@rta/rta-blueprint-library';

import { AppContext } from '../../../app/app-context';
import { DisplayMode } from '@r-core';
import { islandMenuConfig } from './island-menu.config';
import { useActionMenuLayer } from '@r-services/render-layers';
import { SvgActionMenu } from '@r-components';

export type IslandActionProps = {
	islandId: string;
	offset?: { x?: number; y?: number };
};

export const IslandActions = (props: IslandActionProps): React.ReactElement => {
	const { islandId, offset = { x: 0, y: 0 }} = props;

	const {
		controller,
		controller: { options, kitchen, navigation }
	} = useContext(AppContext);

	// short circuit
	if (navigation.displayMode !== DisplayMode.Overhead) return <></>;
	if (!options.contextMenu) return <></>;

	const island: Island | null = kitchen.design.islands.findById(islandId);

	const isSource = island.connections.children.some((connection) => connection.isSource);
	const restrictedIsland = island.isDefaultIsland;

	if (isSource && island.islandConnectionCount === 1 && !restrictedIsland) {
		// Use the render layer system for better performance
		// useActionMenuLayer({
		// 	id: `island-actions-${islandId}`,
		// 	x: island.origin.x,
		// 	y: island.origin.y,
		// 	angleCorrection: island.axis.y,
		// 	items: islandMenuConfig(island, { controller, islandId }),
		// 	priority: 0
		// });

		return <SvgActionMenu {...{
			x: 0,
			y: 0,
			angleCorrection: -island.axis.y,
			items: islandMenuConfig(island, { controller, islandId })
		}}/>;

		// return islandMenuConfig(island, { controller, islandId })

		// return <></>; // Element is rendered by the render layer system
	}

	return <></>;
};


